import { ReactNode } from 'react';
import { Button } from '@mui/material';
import { StyledToolBar } from '@components';
import { DownloadIcon } from '../../../assets/icons/icons';

interface StyledToolBarProps {
  children?: ReactNode;
  onExport?: () => void;
  exportLoading?: boolean;
  onVerifyAll?: () => void;
  verifyAllLoading?: boolean;
  disableVerifyAll?: boolean;
}

const VerificationsToolBar = ({ 
  onExport, 
  exportLoading, 
  // onVerifyAll, 
  // verifyAllLoading,
  // disableVerifyAll
}: StyledToolBarProps): JSX.Element => {
  return (
    <StyledToolBar>
      {/* {onVerifyAll && (
        <Button 
          onClick={onVerifyAll}
          disabled={verifyAllLoading || !!disableVerifyAll}
          startIcon={<UserWithBadgeIcon />}
          sx={{ ml: 1 }}
        >
          Verify All
        </Button>
      )} */}
      {onExport && (
        <Button
          onClick={onExport}
          disabled={exportLoading}
          startIcon={<DownloadIcon />}
          sx={{ ml: 1 }}
        >
          Export CSV
        </Button>
      )}
    </StyledToolBar>
  );
};

export default VerificationsToolBar;
